import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const initialState = {
    id: null,
    isScorePost: false,
    disable_comments: false,
    hide_comments: false,
    isThemedPost: false,
    isPollPost: false,
    isQuizPost: false,
    txt: "",
    groups: [],
    themeColor: "#1F5FC8",
    // stored as ISO strings, not Moment instances - Moment objects in Redux state fail the
    // serializable-state check on every dispatch (redux-toolkit's serializableStateInvariantMiddleware).
    // Consumers already wrap these with moment(...) before use/display.
    pollEndTime: moment().toISOString(),
    scoreStartTime: moment().toISOString(),
    scoreEndTime: moment().add(2,"days").add(2,"hours").toISOString(),
    photos: [],
    thumbnails: [],
    videos: [],
    attachments: [],
    pollOptions: ["", ""],
    category: "",
    scoreBy: [],
    verifyBy: [],
    isApproved: 0,
    scorePoint: 1,
    scorePoint1: 1,
    scorePoint2: 1,
    scoreCount: 1,
    eventLocation: {
        address: "",
        lat: 0,
        lng: 0
    },
    quizTitle: "",
    quizDesc: "",
    quizData: [],
    quizScoreCount:1,
}

const postSlice = createSlice({
    name: "post",
    initialState,
    reducers: {
        setPostData: (state, action) => {
            state[`${action.payload.key}`] = action.payload.value
        },
        setToInitalPostData: (state, action) => {
            return initialState
        }
    }
})

export const { setPostData, setToInitalPostData } = postSlice.actions

export default postSlice.reducer